import {
  U_NO_BREAK_SPACE,
  U_NON_BREAKING_HYPHEN,
} from '@/utils/unicodeCharacters';
import {
  phoneNumberValidationRegex,
  postalCodeValidationRegex,
} from '@/utils/regex';

/**
 * Numéro de téléphone nord américain, excluant l'indicatif de pays.
 * Autorise des parenthèses facultatives autour du code régional ainsi que des espaces et points pour séparer
 * les différentes parties du numéro.  Lorsque le numéro passé n'est pas valide, la valeur originale est retournée.
 *
 * @example 555-555-5555 // valide
 * @example 555.555.5555 // valide
 * @example 555 555 5555 // valide
 * @example (555)555 5555 // valide
 * @example (555)-555-5555 // valide
 * @example 5555555555 // valide
 */
function formatPhoneNumber(value: string): string {
  const match = value.trim().match(phoneNumberValidationRegex);
  return match
    ? `(${match[1]})${U_NO_BREAK_SPACE + match[2] + U_NON_BREAKING_HYPHEN + match[3]}`
    : value;
}

/**
 * Formate/normalise un code postal canadien. Lorsque la valeur passée en paramètres est invalide,
 * la valeur originale est retournée.
 *
 * @example H5A1K6 // valide
 * @example H5A 1K6 // valide avec un espace
 * @example H5A-1K6 // valide avec un trait d'union
 * @example Z5A1K6 // non valide, format est bon mais lettre non valide injectée
 * @example HBA1K6 // non valide, format invalide
 *
 * @see https://www.canadapost-postescanada.ca/cpc/en/support/articles/addressing-guidelines/postal-codes.page
 */
function formatPostalCode(value: string): string {
  const matchedValue = value.trim().toUpperCase().replace(/[-\s]?/g, '').match(postalCodeValidationRegex);

  return matchedValue
    ? `${matchedValue[0].slice(0, 3) + U_NO_BREAK_SPACE + matchedValue[0].slice(3)}`
    : value;
}

export {
  formatPhoneNumber,
  formatPostalCode,
};
